import api from '../Utils/api'

export const updateTaskStatus = async (id, data) => {
  const apiResponse = await api('POST', `task-app/status/${id}`, data)
  return apiResponse
}

export const fetchTask = async (id) => {
  const apiResponse = await api('GET', `task-app/${id}`, null)
  return apiResponse
}

export const createTask = async (data) => {
  const apiResponse = await api('POST', 'task-app/create', data)
  return apiResponse
}

export const updateTask = async (id, data) => {
  const apiResponse = await api('PUT', `task-app/update/${id}`, data)
  return apiResponse
}

export const deleteTask = async (id) => {
  const apiResponse = await api('GET', `tasks/delete/${id}`, null)
  return apiResponse
}

export const fetchTaskComments = async (id) => {
  const apiResponse = await api('GET', `task-comments/${id}`, null)
  return apiResponse
}

export const addTaskComment = async (id, data) => {
  const apiResponse = await api('POST', `task-comments/${id}`, data)
  return apiResponse
}

export const sendReminder = async (id) => {
  const apiResponse = await api('POST', `tasks/send-reminder/${id}`, null)
  return apiResponse
}
